module.exports = __webpack_public_path__ + "img/just-eat.c0dcbc8c.svg";